import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { machineProfile, sensor } from "../../../api/index.js";
import {
  formatDateOnly,
  formatDateTime,
  formatTimeOnly,
} from "../../../utils/helper.jsx";
import { useAuth } from "../../../contexts/AuthContext.jsx";
const thresholdConfig = [
  { name: "observe", color: "#EAE4AF" },
  { name: "alert", color: "#FFBE7E" },
  { name: "critical", color: "#FF779C" },
];
function VibrationTab({
  hodeThreshold = false,
  feature_name,
  threshold_id,
  chart_type,
  machine,
  deployment,
  min_date,
  max_date,
}) {
  const { config } = useAuth();
  const [selectedInterval, setSelectedInterval] = useState("Custom");
  const [vibrationData, setVibrationData] = useState([]);
  const [axis, setAxis] = useState("");
  const [selectedThreshold, setSelectedThreshold] = useState([]);
  const [listThreshold, setListThreshold] = useState({});
  const [maxY, setMaxY] = useState("");
  const getThershold = async () => {
    const threshold = await machineProfile.getThreshold(machine.id, {
      deployment_id: deployment.id,
      threshold_id: threshold_id,
      feature_name: feature_name || "rms_vel",
    });
    if (threshold.ok) {
      const body = await threshold.json();
      let data = body.data;
      setListThreshold(data);
    }
  };
  useEffect(() => {
    const getData = async () => {
      //console.log("geting sensor data");
      const query = {
        sensor_id: deployment.sensor_id,
        machine_element_id: deployment.machine_element_id,
        deployment_id: deployment.id,
        interval: selectedInterval,
        start: min_date,
        end: max_date,
        chart_type: chart_type,
      };
      const result = await sensor.liveVibration(query);
      if (result.ok) {
        const body = await result.json();
        let data = body.data;
        // if (config.charts === "pk_pk_acc") {
        //   data.forEach((d) => {
        //     d.x = Math.round((d.x / 9.806) * 1000) / 1000;
        //     d.y = Math.round((d.y / 9.806) * 1000) / 1000;
        //     d.z = Math.round((d.z / 9.806) * 1000) / 1000;
        //   });
        // }

        if (selectedInterval == "Month")
          data = data.map((s) => ({ ...s, name: formatDateOnly(s.name) }));
        if (selectedInterval == "Week")
          data = data.map((s) => ({ ...s, name: formatDateOnly(s.name) }));
        if (selectedInterval == "Day")
          data = data.map((s) => ({
            ...s,
            name: formatDateOnly(s.name),
          }));
        if (selectedInterval == "Hour")
          data = data.map((s) => ({
            ...s,
            name: formatDateOnly(s.name),
          }));
        if (selectedInterval == "Custom")
          data = data.map((s) => ({
            ...s,
            name: formatDateOnly(s.name),
          }));

        const maxx = Math.max(
          ...data.map((d) => (d.x ? parseFloat(d.x) : 0))
        ).toFixed(2);
        const maxy = Math.max(
          ...data.map((d) => (d.y ? parseFloat(d.y) : 0))
        ).toFixed(2);
        const maxz = Math.max(
          ...data.map((d) => (d.z ? parseFloat(d.z) : 0))
        ).toFixed(2);
        const maxz_long = Math.max(
          ...data.map((d) => (d.z_long ? parseFloat(d.z_long) : 0))
        ).toFixed(2);

        const max_all = [maxx, maxy, maxz, maxz_long];
        const max = Math.max(...max_all);
        setMaxY(parseInt(max) + 1);
        setVibrationData(data);
      }
    };

    getData();
    getThershold();
  }, []);

  const changeThreshold = (e) => {
    setAxis(e.target.value);
    let selected = [];
    if (e.target.value === "ZAxisLong") {
      selected = listThreshold.z_long || [];
    }
    if (e.target.value === "ZAxisLow") {
      selected = listThreshold.z || [];
    }
    if (e.target.value === "XAxisLow") {
      selected = listThreshold.x || [];
    }
    if (e.target.value === "") {
      setSelectedThreshold([]);
    }
    if (e.target.value === "YAxisLow") {
      selected = listThreshold.y || [];
    }
    // if (config.charts === "pk_pk_acc") {
    //   selected.forEach((s) => {
    //     s.threshold_value =
    //       Math.round((s.threshold_value / 9.806) * 1000) / 1000;
    //   });
    // }
    setSelectedThreshold(selected);
  };
  function VibrationChart({
    maxYData,
    selectedAxis,
    threshold,
    vibrationData,
    yKey,
    xKey,
    zKey,
    zLongKey,
  }) {
    const [xAxis, setXAxis] = useState(true);
    const [yAxis, setYAxis] = useState(true);
    const [zAxis, setZAxis] = useState(true);
    const [zAxisHigh, setZAxisHigh] = useState(true);
    const [maxY, setMaxY] = useState("auto");
    useEffect(() => {
      const max = Math.max(
        ...threshold.map((d) => {
          if (d.threshold_value) {
            return d.threshold_value;
          } else {
            return 0;
          }
        })
      );
      if (threshold.length) {
        if (max) setMaxY(parseInt(max) + 1);
      } else {
        if (maxYData) {
          setMaxY(parseInt(maxYData) + 1);
        }
      }
    }, [threshold]);
    // useEffect(() => {
    //   console.log("maxY", maxY);
    // }, [maxY]);
    useEffect(() => {
      if (selectedAxis === "ZAxisLong") {
        setZAxisHigh(true);
        setZAxis(false);
        setYAxis(false);
        setXAxis(false);
      }
      if (selectedAxis === "ZAxisLow") {
        setZAxisHigh(false);
        setZAxis(true);
        setYAxis(false);
        setXAxis(false);
      }
      if (selectedAxis === "XAxisLow") {
        setZAxisHigh(false);
        setZAxis(false);
        setYAxis(false);
        setXAxis(true);
      }
      if (selectedAxis === "YAxisLow") {
        setZAxisHigh(false);
        setZAxis(false);
        setYAxis(true);
        setXAxis(false);
      }
      if (selectedAxis === "") {
        setZAxisHigh(true);
        setZAxis(true);
        setYAxis(true);
        setXAxis(true);
      }
    }, [selectedAxis]);
    const toggleXAxis = () => {
      if (selectedAxis === "XAxisLow" || selectedAxis === "") {
        setXAxis(!xAxis);
      }
    };
    const toggleYAxis = () => {
      if (selectedAxis === "YAxisLow" || selectedAxis === "") {
        setYAxis(!yAxis);
      }
    };
    const toggleZAxis = () => {
      if (selectedAxis === "ZAxisLow" || selectedAxis === "") {
        setZAxis(!zAxis);
      }
    };
    return (
      <>
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            marginTop: { xs: "40px", sm: "40px", md: "10px", lg: "10px" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{ display: "flex", margin: "0 8px", cursor: "pointer" }}
            onClick={toggleXAxis}
          >
            <img
              src="/icons/x_axis.png"
              alt=""
              style={{
                height: "14px",
                marginTop: "3px",
                marginRight: "5px",
                opacity: xAxis ? 1 : 0.2,
              }}
            />{" "}
            <div>X-Axis</div>
          </div>
          <div
            style={{ display: "flex", margin: "0 8px", cursor: "pointer" }}
            onClick={toggleYAxis}
          >
            <img
              src="/icons/y_axis.png"
              alt=""
              style={{
                height: "14px",
                marginTop: "3px",
                marginRight: "5px",
                opacity: yAxis ? 1 : 0.2,
              }}
            />{" "}
            <div>Y-Axis</div>
          </div>
          <div
            style={{ display: "flex", margin: "0 8px", cursor: "pointer" }}
            onClick={toggleZAxis}
          >
            <img
              src="/icons/z_axis.png"
              alt=""
              style={{
                height: "14px",
                marginTop: "3px",
                marginRight: "5px",
                opacity: zAxis ? 1 : 0.2,
              }}
            />{" "}
            <div>Z-Axis</div>
          </div>
          {/*<div*/}
          {/*  style={{ display: "flex", margin: "0 8px", cursor: "pointer" }}*/}
          {/*  onClick={toggleZAxisHigh}*/}
          {/*  // className={zAxisHigh ? "toggle-active" : "toggle-axis"}*/}
          {/*>*/}
          {/*  <img*/}
          {/*    src="/icons/z_axis_long.png"*/}
          {/*    alt=""*/}
          {/*    style={{*/}
          {/*      height: "14px",*/}
          {/*      marginTop: "3px",*/}
          {/*      marginRight: "5px",*/}
          {/*      opacity: zAxisHigh ? 1 : 0.2,*/}
          {/*    }}*/}
          {/*  />{" "}*/}
          {/*  <div>ZAxis Long</div>*/}
          {/*</div>*/}
        </div>
        <div style={{ overflowX: "auto" }}>
          <div
            style={{
              width: {
                xs: "550px",
                md: "auto",
                lg: "auto",
                sm: "550px",
              },
            }}
          >
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                width={500}
                height={300}
                fontSize={13}
                margin={{ left: 0 }}
                data={vibrationData}
              >
                <CartesianGrid opacity={0.4} strokeDasharray="2 2" />
                {/*<ReferenceLine strokeDasharray="3 3" y={10} stroke={"#ff0000"} />*/}
                {threshold.map((t, index) => {
                  const color = thresholdConfig.find(
                    (c) => c.name === t.threshold_name
                  );
                  if (color) {
                    return (
                      <ReferenceLine
                        key={index}
                        strokeDasharray="3 3"
                        y={t.threshold_value}
                        strokeWidth={2}
                        stroke={color.color}
                      />
                    );
                  }
                })}
                <XAxis
                  dataKey={"name"}
                  tickLine={false}
                  height={60}
                  label={{
                    value: "Date",
                    position: "center",
                  }}
                />
                {/*for domain we get max value from threshold value*/}
                <YAxis
                  width={90}
                  domain={[0, maxY]}
                  label={{
                    value:
                      chart_type === "peak_acc"
                        ? "Peak Acceleration m/s^2"
                        : chart_type === "pk_pk_acc"
                        ? "Peak-to-Peak Acceleration (m/s^2)"
                        : "RMS Velocity mm/s",
                    angle: -90,
                    position: "center",
                  }}
                  tickLine={false}
                />
                <Tooltip />
                {xAxis && (
                  <Line
                    opacity={xAxis ? 1 : 0}
                    connectNulls={true}
                    type={"monotone"}
                    dot={false}
                    dataKey={xKey}
                    stroke="#8884d8"
                    strokeWidth={1}
                  />
                )}
                {yAxis && (
                  <Line
                    opacity={yAxis ? 1 : 0}
                    connectNulls={true}
                    type="monotone"
                    dot={false}
                    dataKey={yKey}
                    stroke="#FFD698"
                    strokeWidth={1}
                  />
                )}
                {zAxis && (
                  <Line
                    opacity={zAxis ? 1 : 0}
                    connectNulls={true}
                    type="monotone"
                    dot={false}
                    dataKey={zKey}
                    stroke="#93EEC8"
                    strokeWidth={1}
                  />
                )}

                {/*<Line*/}
                {/*  opacity={zAxisHigh ? 1 : 0}*/}
                {/*  connectNulls={true}*/}
                {/*  type="monotone"*/}
                {/*  dot={false}*/}
                {/*  dataKey={zLongKey}*/}
                {/*  stroke="#93EEC8"*/}
                {/*  strokeWidth={1}*/}
                {/*/>*/}

                {/* TODO: This needs to be refactored */}
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </>
    );
  }

  return (
    <div>
      {hodeThreshold ? null : (
        <div style={{ width: "200px" }}>
          <select
            value={axis}
            onChange={changeThreshold}
            className={"input-filter-select"}
          >
            <option value="" label={"- Select Threshold -"}></option>
            <option value="XAxisLow" label={"X-Axis"}></option>
            <option value="YAxisLow" label={"Y-Axis"}></option>
            <option value="ZAxisLow" label={"Z-Axis"}></option>
          </select>
        </div>
      )}

      <VibrationChart
        maxYData={maxY}
        threshold={selectedThreshold}
        selectedAxis={axis}
        vibrationData={vibrationData}
        yKey="y"
        xKey="x"
        zKey="z"
        zLongKey="z_long"
      />
    </div>
  );
}

export default VibrationTab;
